var _style, _g, _g2, _g3, _g4, _g5, _g6, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{fill:#616160;}\r\n\t.st2{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rough",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8,13.3c-4.7,0-7-4.7-7-5.3s2.3-5.3,7-5.3c4.7,0,7,4.8,7,5.4C15,8.7,12.7,13.3,8,13.3z M2,8 c0.2,0.6,2.3,4.3,6,4.3c3.7,0,5.7-3.4,6-4.1c-0.2-0.7-2.2-4.4-6-4.4C4.3,3.7,2.2,7.4,2,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8,10.8c-1.6,0-2.8-1.3-2.8-2.8S6.4,5.2,8,5.2s2.8,1.3,2.8,2.8S9.6,10.8,8,10.8z M8,6.2C7,6.2,6.2,7,6.2,8 S7,9.8,8,9.8S9.8,9,9.8,8S9,6.2,8,6.2z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Strokes"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Annotation__x2B__Rough",
    className: "st0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 16,
    height: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b058b4249dde32d0833f3a8f0c5a4fa0.svg";
export { ForwardRef as ReactComponent };